import { Scalars } from '@varo/graphql-schema-types';
import theme from 'shared/styles/theme';

type VXLColors =
  (typeof theme.color.expressive)[keyof typeof theme.color.expressive];
export type BackgroundColor = VXLColors;
export type FontColor = VXLColors;

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Xlarge = 'Xlarge',
}

export type LavenderType = ['lavender', 'wine'];
export type ForestType = ['forest', 'orchid'];
export type SunsetType = ['sunset', 'sand'];
export type LimeType = ['lime', 'forest'];
export type EggplantType = ['eggplant', 'blush'];

export type UserAvatarTheme =
  | typeof Lavender
  | typeof Forest
  | typeof Sunset
  | typeof Lime
  | typeof Eggplant;

const { expressive } = theme.color;

export const Lavender = [expressive.lavender, expressive.wine] as LavenderType;
export const Forest = [expressive.forest, expressive.orchid] as ForestType;
export const Sunset = [expressive.sunset, expressive.sand] as SunsetType;
export const Lime = [expressive.lime, expressive.forest] as LimeType;
export const Eggplant = [expressive.eggplant, expressive.blush] as EggplantType;

export const getLastLetter = (name: Scalars['Copy']) => {
  const lastLetter = (name as string).trim().at(-1)?.toLowerCase();
  return lastLetter;
};

export const defaultColors = ({
  font,
  background,
}: {
  font: FontColor;
  background: BackgroundColor;
}) => {
  return {
    color: font ?? theme.color.expressive.varoPurple,
    backgroundColor: background ?? theme.color.expressive.blush,
  };
};

export const getInitials = (name: string): string => {
  const nameArray = name.split(' ');

  // in case instead of initials someone passes in a full name
  const initials =
    nameArray.length >= 2 ? nameArray.map((name) => name[0]).join('') : name;
  // no way to verify initials are only 2 letters so we need to check and reduce to two letters
  const twoInitials =
    initials.length > 2 ? `${initials[0]}${initials.at(-1)}` : initials;
  return twoInitials;
};

export const genericIconSize = (userAvatarSize: Size) => {
  switch (userAvatarSize) {
    case Size.Small:
      return { iconSize: 16, padding: theme.spacing.xs };
    case Size.Medium:
      return { iconSize: 24, padding: theme.spacing.s };
    case Size.Large:
      return { iconSize: 54, padding: theme.spacing.s };
    case Size.Xlarge:
      return { iconSize: 128, padding: theme.spacing.m };
  }
};
